<!--
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-17 22:25:57
 * @LastEditors: wangyunlin wangyunlin@morewis.com
 * @LastEditTime: 2023-02-24 09:26:28
 * @FilePath: \douyin\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <van-overlay :show="show" >
      <div class="wrapper" @click.stop>
        <!-- <div class="block">
          感谢支持和信任我们的新老客户,很抱歉的和你说,由于物业施工临时断电1小时(今晚<i class="red">22:00-00:40</i>)。影响了我们服务器设备正常运行，预计恢复在今晚11点以后。断电期间将会影响到我们的抖币/快币充值。由此带来的不便敬请谅解，感恩！
        </div>   -->
        <div class="block">
          您好，由于近期充值系统诈骗高发，为了保障您的资金安全，系统正在升级维护中，充值稍后恢复，给您带来不便，深感抱歉！
        </div>
      </div>
    </van-overlay>
        <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  },
  computed: {
    webInfoObj() {
      const _webInfo = this.$store.state.websiteInfo;
      return _webInfo[location.host] ?? _webInfo.defaultData;
    },
  },
  data() {
    return {
      show: false,
      enable: true, // 是否开启机型访问限制
    }
  },
  created() {

    // 微信中如何禁止分享给好友和朋友圈
    document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu');
        });
    
    console.log(this.webInfoObj);
    const { disabledAndroid } = this.webInfoObj;
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (!isiOS && disabledAndroid) {
      this.$router.push("/error");
    }


  }
}
</script>




<style lang="less">
@import './assets/css/index.less';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
* {
  padding: 0;
  margin: 0;
}
</style>

<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 80%;
    background-color: #fff;
    border-radius: 6px;
    font-size: 16px;
    padding: 20px;
    color: #666;
    text-align: justify;
    line-height: 27px;

  }
  .red {
    color: red;
    font-weight: 700;
  }
</style>
